module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-cc-13be37291faff79335a7a223229e9257.svg";